module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.modifier === 'display') ? _c('display', {
    attrs: {
      "general": _vm.general,
      "item": _vm.item
    }
  }) : _vm._e(), _vm._v(" "), (_vm.modifier === 'backgroundColor') ? _c('background-color', {
    attrs: {
      "general": _vm.general,
      "item": _vm.item
    }
  }) : _vm._e(), _vm._v(" "), (_vm.modifier === 'borderColor') ? _c('border-color', {
    attrs: {
      "general": _vm.general,
      "item": _vm.item
    }
  }) : _vm._e(), _vm._v(" "), (_vm.modifier === 'borderRadius') ? _c('border-radius', {
    attrs: {
      "general": _vm.general,
      "item": _vm.item
    }
  }) : _vm._e(), _vm._v(" "), (_vm.modifier === 'color' && _vm.general) ? _c('color', {
    attrs: {
      "general": _vm.general,
      "item": _vm.item
    }
  }) : _vm._e(), _vm._v(" "), (_vm.modifier === 'fontFamily') ? _c('font-family', {
    attrs: {
      "general": _vm.general,
      "item": _vm.item
    }
  }) : _vm._e(), _vm._v(" "), (_vm.modifier === 'fontSize') ? _c('font-size', {
    attrs: {
      "general": _vm.general,
      "item": _vm.item
    }
  }) : _vm._e(), _vm._v(" "), (_vm.modifier === 'height') ? _c('height', {
    attrs: {
      "general": _vm.general,
      "item": _vm.item
    }
  }) : _vm._e(), _vm._v(" "), (_vm.modifier === 'width') ? _c('width', {
    attrs: {
      "general": _vm.general,
      "item": _vm.item
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-5a3d5b14!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/modifiers/editors/Main.vue
 ** module id = 836
 ** module chunks = 1
 **/